import React from "react";
import styled from "styled-components";
import AppLink from "components/common/style/link/AppLink";
import DeleteText from "components/common/style/navigation/DeleteText";
import { useUnitDelete } from "hooks/citajteo/dl_unit/useUnitDelete";
import { QUERY_KEYS } from "constant/react_query";
import { DlUnit } from "model/dl_unit/DlUnit";
import toast from "react-hot-toast";
import useConfirm from "common/modal/ConfirmDialog";

type UnitCatEditProps = {
  unit: DlUnit;
};

const UnitCatEdit = ({ unit }: UnitCatEditProps) => {
  const { unitDeleteMutate } = useUnitDelete({
    invalidateKeys: [QUERY_KEYS.CITAJTEO_DL_UNIT_SEARCH],
  });
  const confirm = useConfirm();

  const handleUnitDelete = async (unit: DlUnit) => {
    const confirmed = await confirm({
      title: "Brisanje jedinice",
      message: `Da li želite da obrišete jedinicu ${unit.slug}?`,
    });

    if (!confirmed) {
      return;
    }

    unitDeleteMutate(unit.id, {
      onSuccess: () => {
        toast.success("Uspešno brisanje jedinice.");
      },
      onError: (error) => {
        console.error("Error deleting unit:", error);
        toast.error("Greška prilikom brisanja jedinice.");
      },
    });
  };

  return (
    <ListItem>
      <AppLink to={`/admin-dashboard/dl-unit-edit/${unit.id}`}>polja</AppLink>
      <br />
      {unit.slug}
      <DeleteItem>
        <DeleteText onClick={() => handleUnitDelete(unit)}>obriši</DeleteText>
      </DeleteItem>
    </ListItem>
  );
};

export default UnitCatEdit;

const ListItem = styled.div`
  margin-top: 1em;
  width: 100%;
  line-height: 1.5em;
`;

const DeleteItem = styled.div`
  margin-top: 0.5rem;
`;
